import React, { useContext } from "react";
import GenerateSequence from "./GenerateSequence";
import { ChemBioPendingContext } from "../ChemBioPendingContext";
import { TEST_OVERDUE_FLAGS, convertStatusMapToArrayOptions } from "../../../../utils/statusConfig";

const legendContent = convertStatusMapToArrayOptions(TEST_OVERDUE_FLAGS, [], true, false);

const PendingLegendSection = () => {
  const {
    sequenceCompRef,
    chemDropdown,
  } = useContext(ChemBioPendingContext);
  return (
    <div className={`PendingTable__LegendWrap${chemDropdown ? "--Chem" : ""}`}>
      <div className="PendingTable__Legend">
        {legendContent.map((item, index) => (
          <div key={index} className="PendingTable__Legend__Content">
            {item.type === "circle" && <span style={item.circleStyle} />}
            {item.type === "text" && <span style={item.textStyle}>{`${item.textName}:`}</span>}
            <span>{item.label}</span>
          </div>
        ))}
      </div>
      <GenerateSequence ref={sequenceCompRef} />
    </div>
  );
};

export default PendingLegendSection;
